export default [
  {
    path: '/pickupeurs',
    name: 'pickupeur-list',
    component: () => import('@/views/users/pickupeurs/Index.vue'),
    meta: {
      pageTitle: 'Liste des ramasseurs',
      pageDesc: 'Consultez, filtrez et gérez les ramasseurs de votre flotte logistique.',
      breadcrumb: [
        {
          text: 'Ramasseurs',
          active: true,
        },
      ],
      resource: 'Auth',
      roles: ['admin', 'superadmin', 'manager'],
      requireLogin: true,
    },
  },
  {
    path: '/pickupeurs/create',
    name: 'pickupeur-create',
    component: () => import('@/views/users/pickupeurs/Create.vue'),
    meta: {
      pageTitle: 'Ajouter un ramasseur',
      pageDesc: 'Ajoutez un nouveau ramasseur à votre flotte logistique.',
      breadcrumb: [
        {
          text: 'Ramasseurs',
          to: { name: 'pickupeur-list' },
        },
        {
          text: 'Ajouter',
          active: true,
        },
      ],
      resource: 'Auth',
      requireLogin: true,
      roles: ['admin', 'superadmin'],
      admin: true,
    },
  },
  {
    path: '/pickupeurs/edit/:id',
    name: 'pickupeur-edit',
    component: () => import('@/views/users/pickupeurs/Edit.vue'),
    meta: {
      pageTitle: 'Modifier un ramasseur',
      pageDesc: 'Modifiez les informations d\'un ramasseur existant.',
      breadcrumb: [
        {
          text: 'Ramasseurs',
          to: { name: 'pickupeur-list' },
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
      resource: 'Auth',
      roles: ['admin', 'superadmin'],
      requireLogin: true,
      admin: true,
    },
  },
  {
    path: '/pickupeurs/show/:id',
    name: 'pickupeur-show',
    component: () => import('@/views/users/pickupeurs/Show.vue'),
    meta: {
      pageTitle: 'Détails du ramasseur',
      pageDesc: 'Consultez les informations détaillées d\'un ramasseur.',
      breadcrumb: [
        {
          text: 'Ramasseurs',
          to: { name: 'pickupeur-list' },
        },
        {
          text: 'Détails',
          active: true,
        },
      ],
      resource: 'Auth',
      roles: ['admin', 'superadmin', 'manager'],
      requireLogin: true,
    },
  },
]
